import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import Meta from "vue-meta";
import store from "./store";
import VueAnalytics from 'vue-analytics';

Vue.config.productionTip = false;

//and then use it in main.js
Vue.use(VueAnalytics, {
    id: 'UA-28767852-1',
    router
})

Vue.use(Meta);
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount("#app");
